var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientPortalIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "portal_black_add_2",
    "data-name": "portal black add 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.92,
    height: 13.988,
    viewBox: "0 0 18.92 13.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "client_portal_-_black",
    "data-name": "client portal - black",
    transform: "translate(0 0.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-843.771 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_md_copy_2",
    "data-name": "laptop md copy 2",
    transform: "translate(842 335.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(1.771 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,2.92A2.062,2.062,0,0,1,2.07.86H12.659a2.062,2.062,0,0,1,2.07,2.06V10.7a2.062,2.062,0,0,1-2.07,2.06H2.07A2.062,2.062,0,0,1,0,10.7Zm1.383,0a.685.685,0,0,1,.687-.684H12.659a.685.685,0,0,1,.687.684V9.792a.685.685,0,0,1-.687.684H2.07a.685.685,0,0,1-.687-.684Z",
    transform: "translate(0 -0.86)",
    fill: "#020202",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "people_sm",
    "data-name": "people sm",
    transform: "translate(886.011 337.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-33 2.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M6.489,12.294a.575.575,0,0,1-.6.659H.608a.575.575,0,0,1-.6-.659,3.31,3.31,0,0,1,6.484,0Z",
    transform: "translate(1.426 -3.513)",
    fill: "#020202",
    stroke: "#fff",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M14.929,12.79h-.972c0-.061-.014-.117-.023-.178a4.019,4.019,0,0,0-.714-1.6,1.863,1.863,0,0,1,2.225,1.169.482.482,0,0,1-.512.606Z",
    transform: "translate(-7.234 -2.647) rotate(-7)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M12.69,6.53a1.05,1.05,0,1,0-1.05-1.05A1.051,1.051,0,0,0,12.69,6.53Z",
    transform: "translate(-5.144 -0.593)",
    fill: "#020202",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M6.66,3.58A1.75,1.75,0,1,1,4.91,1.83,1.75,1.75,0,0,1,6.66,3.58Z",
    transform: "translate(-0.227 0.6)",
    fill: "#020202",
    stroke: "#fff",
    strokeWidth: 0.5
  })))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(4.96)",
    fill: "#050505",
    fontSize: 8,
    fontFamily: "HelveticaNeue, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientPortalIconAdd);
export default __webpack_public_path__ + "static/media/client-portal-icon-add.e81ff22a21b04eaecabfa7ec3611e614.svg";
export { ForwardRef as ReactComponent };